module.exports = __webpack_public_path__ + "static/media/fill_grey_16.5ff9fc79.svg";